import { render, staticRenderFns } from "./QuizByKtiIndex.vue?vue&type=template&id=b4f8d362"
import script from "./QuizByKtiIndex.vue?vue&type=script&lang=js"
export * from "./QuizByKtiIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports